module.exports = __webpack_public_path__ + "static/media/rapid.caa8f8d2.png";